import { Controller as BaseController } from 'stimulus'
import './index.scss'

export class Controller extends BaseController {
  static targets = ['self', 'form'];

  edit(event) {
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass)
  }

  cancel(event) {
    this.formTarget.reset()
    this.selfTarget.classList.remove(event.currentTarget.dataset.editingClass)
  }
}
